import useSite from "@casino/legacy/client/hooks/useSite";
import Translate from "@casino/legacy/client/shared/i18n/Translate";
import PrimaryButton from "@casino/legacy/client/shared/styles/PrimaryButton";
import { FormItem } from "@casino/legacyUi/form/FormItem";

type Props = {
  loading: boolean;
  handleSubmit?: () => void;
};

const Submit: FC<Props> = ({ loading, handleSubmit }) => {
  const { isBitcasino } = useSite();
  return (
    <FormItem>
      <PrimaryButton
        isBitcasino={isBitcasino}
        variant="primary"
        fullWidth
        animation={loading ? "progress" : undefined}
        onClick={handleSubmit}
        data-testid="register-submit"
      >
        <Translate id="profile.create_account" />
      </PrimaryButton>
    </FormItem>
  );
};

export default Submit;
